import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
//primeReact
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { updateParcels } from "../../../../../../services/Parcel/updateParcel";
import CalendarInput from "../../../../../../components/input/CalendarInput";
import { useParcelContext } from "./ParcelContext";

const ModalUpdateDueDate = ({ dynamicTitle }) => {
  const {
    control,
    handleSubmit: handleUpdateDueDate,
    reset: resetUpdateDueDate,
    errors,
  } = useForm();

  const {
    idSale,

    itemsSelected,
    setItemsSelected,
    setSelectAll,

    setSelectedValue,

    refetch,

    setIsModalVisibleUpdateDueDate,
    isModalVisibleUpdateDueDate,
  } = useParcelContext();

  const style = {
    width: window.innerWidth <= 997 ? "50vw" : "50vw",
  };

  // Função para formatar data no formato 'yyyy-MM-dd'
  const formatToBackendDate = (date) => {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    } else {
      return ""; // Retorna uma string vazia se o campo estiver vazio
    }
  };

  function sendUpdateDueDate(data) {
    const selectedParcelIds = itemsSelected.map(
      (selectedParcel) => selectedParcel.id
    );

    let obj = {
      action: "change_due_date",
      sale_id: idSale,
      installments: {},
    };

    obj.date = data.due_date;

    selectedParcelIds.forEach((id, index) => {
      obj.installments[index] = {
        id: id,
      };
    });
    setIsModalVisibleUpdateDueDate(false);
    const notification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );
    // Executa a função de atualização das parcelas
    updateParcels(obj)
      .then(() => {
        // Em seguida, atualiza os itens selecionados e chama a função de refresh
        setItemsSelected([]);
        setSelectAll([]);
        resetUpdateDueDate();
        return refetch();
      })
      .then(() => {
        // Depois que o refresh for concluído com sucesso, atualize a notificação para indicar sucesso
        toast.update(notification, {
          render: "Datas de vencimento alteradas com sucesso!",
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      })
      .catch((error) => {
        toast.update(notification, {
          render: "Não foi possível alteras as datas de vencimento!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao alterar datas de vencimento:", error);
      });
  }
  return (
    <>
      <Dialog
        header={dynamicTitle}
        id="modal_cad"
        className="rounded-4"
        onHide={() =>
          setIsModalVisibleUpdateDueDate(!isModalVisibleUpdateDueDate)
        }
        visible={isModalVisibleUpdateDueDate}
        style={style}
      >
        <Divider align="left">
          <div className="inline-flex align-items-center">
            <i className="pi pi-user mr-2"></i>
            <b>Nova Data</b>
          </div>
        </Divider>
        <form onSubmit={handleUpdateDueDate(sendUpdateDueDate)}>
          <div>
            <div className="mb-3">
              <CalendarInput
                onChange={(e) => {
                  const dateFormat = formatToBackendDate(e.value);
                  setSelectedValue((prevValue) => ({
                    ...prevValue,
                    due_date: dateFormat,
                  }));
                }}
                className={`w-50 p-inputtext-sm rounded-4`}
                label="Nova Data"
                errors={errors}
                isRequired={true}
                control={control}
                name="due_date"
                dateFormat="dd/mm/yy"
                showButtonBar
                showIcon
              />
            </div>
            <div className="text-center">
              <Button
                rounded
                label="Alterar"
                icon="fa fa-plus"
                type="submit"
                className="p-inputtext-sm m-auto"
              />
            </div>
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default ModalUpdateDueDate;
